import React from 'react';
import { IconProps } from '../../../../../types/components';

export default function Star({ iconClass, width }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      focusable="false"
      role="img"
      viewBox="0 0 640 640"
      className={iconClass}
      width={width}
    >
      <path fill="currentColor" d="M415 189.3L341.5 45.1C337.4 37.1 329.1 32 320.1 32C311.1 32 302.8 37.1 298.7 45.1L225.1 189.3L65.2 214.7C56.3 216.1 48.9 222.4 46.1 231C43.3 239.6 45.6 249 51.9 255.4L166.3 369.9L141.1 529.8C139.7 538.7 143.4 547.7 150.7 553C158 558.3 167.6 559.1 175.7 555L320.1 481.6L464.4 555C472.4 559.1 482.1 558.3 489.4 553C496.7 547.7 500.4 538.8 499 529.8L473.7 369.9L588.1 255.4C594.5 249 596.7 239.6 593.9 231C591.1 222.4 583.8 216.1 574.8 214.7L415 189.3zM410 220.9L554.4 243.9L451.1 347.4C443.9 354.6 440.5 364.9 442.1 375L464.9 519.3L334.6 453C325.5 448.4 314.7 448.4 305.6 453L175.2 519.3L198 374.9C199.6 364.8 196.3 354.5 189 347.3L85.7 243.8L230.1 220.8C240.2 219.2 248.9 212.9 253.6 203.7L320.1 73.6L386.5 203.8C391.1 212.9 399.9 219.3 410 220.9z" />
    </svg>
  );
}
